<template>
  <v-dialog
    v-model="dialog"
    persistent
  >
    <template #activator="{on}">
      <v-btn
        id="openClientIdFilter"
        text
        color="primary"
        v-on="on"
      >
        Filtrar por Cliente ID
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Filtrar por ID's do cliente</v-card-title>
      <v-card-text>
        <form-group>
          <v-row class="py-6">
            <span>A lista pode ser
              iformada por quebra de linha, vírgula ou espaços</span>
          </v-row>
          <v-row>
            <v-textarea
              id="input:list"
              v-model="list"
              label="ID's"
              rows="5"
              outlined
              clearable
              type="number"
            />
          </v-row>
        </form-group>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          @click="close()"
        >
          Cancelar
        </v-btn>
        <v-btn
          id="saveClientIdFilter"
          color="success"
          class="ml-2"
          @click="save()"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FlatListMixin from '@/app/arch/mixins/FlatListMixin';
import FilterMixin from '@/app/arch/components/crud/crud-mixins/FilterMixin';

export default {
  name: 'UserClientIdsFilter',
  mixins: [FlatListMixin, FilterMixin],
  data: () => ({
    dialog: false,
    payload: {
      ClientId: '',
    },
  }),
  watch: {
    'payload.ClientId': {
      immediate: true,
      handler() {
        this.filter();
      },
    },
  },
  methods: {
    save() {
      this.setClientId();
      this.close();
    },
    setClientId() {
      const { flatList } = this;
      if (!Array.isArray(flatList)) {
        if (typeof flatList !== 'string') {
          this.payload.ClientId = '';
        } else {
          this.payload.ClientId = flatList.includes('null') ? '' : flatList;
        }
      } else if (flatList.length > 1) {
        this.payload.ClientId = flatList.join(',');
      } else {
        this.payload.ClientId = String(flatList[0]);
      }
    },
    close() {
      this.dialog = !this.dialog;
    },
  },
};
</script>
